import edit_button from "../edit_button.html";

export default function (nga, admin) {
  var logs = admin.getEntity("logs");
  logs
    .listView()
    .title(
      '<h4>User logs <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga.field("id", "number").label("ID"),
      nga.field("username", "string").label("User"),
      nga.field("user_ip", "string").label("from ip"),
      nga.field("action", "string").label("action"),
      nga.field("action_on", "string").label("Action on"),
      nga
        .field("prev", "string")
        .map(function app(value) {
          if (value != null) {
            const object = JSON.parse(value);

            var result = "";
            if (Array.isArray(object)) {
              var ids = "";
              object.forEach(function (val, index) {
                if (typeof val == "object") {
                  var res = "";
                  Object.keys(val).forEach(function (k, index) {
                    if (typeof val[k] != "object") {
                      res = res + k + ":" + val[k] + ",   ";
                    }
                  });

                  ids = ids + res + ",    ";
                } else {
                  ids = ids + val + ",   ";
                }
              });
              return ids;
            } else {
              if (typeof object == "object") {
                Object.keys(object).forEach(function (k, index) {
                  if (typeof object[k] != "object") {
                    result = result + k + ":" + object[k] + ",   ";
                  }
                });
                return decodeURIComponent(result);
              } else if (typeof object == "string") {
                return object;
              } else {
                return object;
              }
            }
          } else {
            return "";
          }
        })
        .label("Prev"),
      nga
        .field("now", "string")
        .map(function app(value) {
          if (value != null) {
            const object = JSON.parse(value);

            var result = "";
            if (Array.isArray(object)) {
              var ids = "";
              object.forEach(function (val, index) {
                if (typeof val == "object") {
                  var res = "";
                  Object.keys(val).forEach(function (k, index) {
                    if (typeof val[k] != "object") {
                      res = res + k + ":" + val[k] + ",   ";
                    }
                  });

                  ids = ids + res + ",    ";
                } else {
                  ids = ids + val + ",   ";
                }
              });
              return ids;
            } else {
              if (typeof object == "object") {
                Object.keys(object).forEach(function (k, index) {
                  if (typeof object[k] != "object") {
                    result = result + k + ":" + object[k] + ",   ";
                  }
                });
                return decodeURIComponent(result);
              } else if (typeof object == "string") {
                return object;
              } else {
                return object;
              }
            }
          } else {
            return "";
          }
        })
        .label("Now"),
      nga
        .field("details", "string")
        .map(function app(value) {
          if (value != null) {
            const object = JSON.parse(value);

            var result = "";
            if (Array.isArray(object)) {
              var ids = "";
              object.forEach(function (val, index) {
                if (typeof val == "object") {
                  var res = "";
                  Object.keys(val).forEach(function (k, index) {
                    if (typeof val[k] != "object") {
                      res = res + k + ":" + val[k] + ",   ";
                    }
                  });

                  ids = ids + res + ",    ";
                } else {
                  ids = ids + val + ",   ";
                }
              });
              return ids;
            } else {
              if (typeof object == "object") {
                Object.keys(object).forEach(function (k, index) {
                  if (typeof object[k] != "object") {
                    result = result + k + ":" + object[k] + ",   ";
                  }
                });
                return decodeURIComponent(result);
              } else if (typeof object == "string") {
                return object;
              } else {
                return object;
              }
            }
          } else {
            return "";
          }
        })
        .label("Details"),
      nga.field("createdAt", "datetime").label("date"),
    ]).filters([
      nga.field('action')
          .attributes({ placeholder: 'action' })
          .label('Action'),
          nga.field('action_on')
          .attributes({ placeholder: 'action on' })
          .label('Action On'),
      nga.field('prev')
          .attributes({ placeholder: 'prev' })
          .label('Previous'),   
      nga.field('now')
          .attributes({ placeholder: 'now' })
          .label('Now'),
      nga.field('details')
          .attributes({ placeholder: 'details' })
          .label('Details'),
  ])
  .listActions(["show"]);

  logs
    .showView()
    .title(
      '<h4>Logs <i class="fa fa-angle-right" aria-hidden="true"></i> Details</h4>'
    )
    .fields([
      nga.field("id", "number").label("ID"),
      nga.field("user.username", "string").label("User"),
      nga.field("user_ip", "string").label("from ip"),
      nga.field("action", "string").label("action"),
      nga
        .field("details", "json")
        .map(function detailsdecode(value, entry) {
          return JSON.parse(value);
        })
        .label("details"),
      nga.field("createdAt", "date").label("date"),
    ]);

  return logs;
}



// WEBPACK FOOTER //
// ./js/logs/config.js